import {
  isEnabledForEnvironment,
  isExcluded,
  isInEnabled,
} from 'components/Route/utils';
import { floatingButtonsConfig } from '../config';

/**
 * Determines if a floating button should be enabled for the current customer
 * and current environment.
 */
export const isButtonEnabled = (
  buttonId: string,
  currentCustomer: string
): boolean => {
  // Find the button config by ID
  const config = floatingButtonsConfig.find((button) => button.id === buttonId);
  if (!config) return false; // Button config not found → disabled

  // disabled customer check (highest priority)
  if (isExcluded(config.disabledCustomer, currentCustomer)) return false;

  // enabled customer check
  // If enabledCustomer is undefined or empty → enabled for all customers
  const customerEnabled: boolean =
    !config.enabledCustomer || config.enabledCustomer.length === 0
      ? true
      : isInEnabled(config.enabledCustomer, currentCustomer) ?? false;

  // Enabled environment check
  const environmentEnabled: boolean = isEnabledForEnvironment(
    config.enabledEnvironments
  );

  // Button is enabled only if both customer and environment checks pass
  return customerEnabled && environmentEnabled;
};
